<div class="host-qrcode-download">
  <span class="close" (click)="close()">
    <i nz-icon nzType="close" nzTheme="outline"></i>
  </span>
  <div class="content" *ngIf="downloadInfo">
    <ng-container *ngIf="isGlobal">
      <ng-container *ngIf="downloadInfo?.is_under_review else qrcode">
        <div class="in-review">
          The Hostex App is under review and will be available in a few days.
        </div>
      </ng-container>
      <ng-template #qrcode>
        <div class="store-link">
          <a [attr.href]="downloadInfo?.app_store_url" target="_blank">
            <img src="/assets/icon/appstore.png" alt="">
          </a>
          <a [attr.href]="downloadInfo?.google_play_url" target="_blank">
            <img src="/assets/icon/googleplay.png" alt="">
          </a>
        </div>
        <div class="qrcode">
          <img
            [attr.src]="downloadInfo?.qr_code_url"/>
          <p>
            Scan to install
            <!-- {{ "user.download_app" | translate }} -->
            <!-- 下载百居易Hostex APP -->
          </p>
        </div>
      </ng-template>
    </ng-container>

    <ng-container *ngIf="!isGlobal">
      <div class="qrcode">
        <img src="/assets/icon/download-qrcode-new1.jpg" alt="">
        <p>请扫码下载百居易APP</p>
      </div>
    </ng-container>
  </div>
</div>